import React, { useEffect, useState } from 'react';
import { MAX_WAITING_TIME, ROUTES, TELEBINDING_STAGES, TELEBINDING_WAITING_STAGES } from '../../utils/constants';
import { piiWaitingImg } from '../../images/TeleBindingImages/TeleBindingImages';
import { getApiData } from '../../api/api';
import { getTelebindingStageStatus } from '../../services/TelebindingServices';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { getRedirectionRouteForPosv } from '../../utils/handleProgress';

const WaitingScreen = ({ statusEndpoint, onComplete }) => {
    const router = useHistory();
    const [status, setStatus] = useState('waiting');
    const [error, setError] = useState(null);
    const [waitingTime, setWaitingTime] = useState(0)
    const [apiSuccess, setApiSuccess] = useState(false)

    useEffect(() => {
        let fetchInterval;
        let waitingInterval;
        const fetchStatus = async () => {
            try {
                const response = await getTelebindingStageStatus(router);
                console.log({ response: response.telebindingStatus })
                const telebindingStatus = response.telebindingStatus;
                
                if(!TELEBINDING_WAITING_STAGES.includes(telebindingStatus)) {
                     setApiSuccess(true);

                    let redirectionRoute = "";
                    switch(telebindingStatus) {
                        case TELEBINDING_STAGES.POSV:
                            redirectionRoute = getRedirectionRouteForPosv();
                            break
                        case TELEBINDING_STAGES.PAYMENT:
                            redirectionRoute = ROUTES.PAYMENT
                            break
                        case TELEBINDING_STAGES.PII:
                            redirectionRoute = ROUTES.PERSONAL_DETAILS
                            break;
                        default:
                            break;
                    }
                    clearInterval(fetchInterval)
                    clearInterval(waitingInterval)
                    router.push(redirectionRoute)
                }
            } catch (error) {
                console.log({ error })
            }
        };

        const handleWaitingTime = () => {
            setWaitingTime((prev) => {
                console.log({ prev })
                if (prev < 30) {
                    return prev + 1
                } else {
                    clearInterval(waitingInterval)
                    clearInterval(fetchInterval)

                    if(!apiSuccess){
                        router.push(ROUTES.TECHNICAL_ERROR);
                    }
                    return prev
                }
            })

        }

        fetchStatus();
        fetchInterval = setInterval(fetchStatus, 5000);
        waitingInterval = setInterval(handleWaitingTime, 1000)

        return () => {
            clearInterval(fetchInterval)
            clearInterval(waitingInterval)
        };
    }, [statusEndpoint, onComplete]);

    return (

        <>
        <div>
        <div className='pii-waiting-image'>
            <img src={piiWaitingImg} alt="Waiting" />
        </div>
       
        <div className='getting-ready-container'>
        <div className='getting-ready'>
            <h2>Getting Things Ready...</h2>
            <p> Please wait and do not close this window</p>
            
            <div className='loader-cntnr'>
                <div style={{ width: `${Math.ceil((waitingTime / MAX_WAITING_TIME) * 100)}%`, height: "4px", background: "#0092db", transition: "width 0.25s ease-in-out"}}></div>
                <div className='loading-text'><p>Loading...</p> <span>{Math.ceil((waitingTime / MAX_WAITING_TIME) * 100)}%</span></div>
            </div>
        </div> 
        </div>
        
         </div>
        </>
        
    );
};

export default WaitingScreen;
